import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

interface CachedImage {
  url: string;
  blob: Blob;
}

@Injectable()
export class ImageService {
  private http = inject(HttpClient);

  private urls: string[] = [];

  private images: CachedImage[] = [];

  set cacheUrls(urls: string[]) {
    this.urls = [...urls];
  }
  get cacheUrls(): string[] {
    return this.cacheUrls;
  }
  set cachedImages(image: CachedImage) {
    this.images.push(image);
  }

  getImage(url: string, maxAge = 43200): Observable<any> {
    const index = this.images.findIndex(image => image.url === url);
    if (index > -1) {
      const image = this.images[index];
      return of(URL.createObjectURL(image.blob));
    }
    const httpHeaders: HttpHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'max-age': maxAge + '',
      's-maxage': '604800',
    });
    return this.http
      .get(url, {
        responseType: 'blob',
        //      headers: httpHeaders
      })
      .pipe(
        tap(blob => this.checkAndCacheImage(url, blob)),
        catchError(err => throwError(err))
      );
  }

  checkAndCacheImage(url: string, blob: Blob): void {
    if (this.urls.indexOf(url) > -1) {
      this.images.push({ url, blob });
    }
  }
}
